import type { ComponentType, SVGProps } from 'react';

import BEFlag from '@/assets/icons/flags/be.svg?react';
import DEFlag from '@/assets/icons/flags/de.svg?react';
import ESFlag from '@/assets/icons/flags/es.svg?react';
import FRFlag from '@/assets/icons/flags/fr.svg?react';
import ITFlag from '@/assets/icons/flags/it.svg?react';
import LUFlag from '@/assets/icons/flags/lu.svg?react';
import { resources } from '@/locales/resources';

type Locale = keyof typeof resources;
type FlagIcon = ComponentType<SVGProps<SVGSVGElement>>;

const flagByCountry: Record<string, FlagIcon> = {
  FR: FRFlag,
  DE: DEFlag,
  ES: ESFlag,
  IT: ITFlag,
  BE: BEFlag,
  LU: LUFlag,
};

export const supportedLocales = Object.keys(resources) as Locale[];

export function getLocaleFlag(locale: Locale): FlagIcon {
  const [, country] = locale.split('-');

  return flagByCountry[country] ?? FRFlag;
}
